import React from 'react';
import Helmet from 'react-helmet';
import publisher_logo from "../img/logo_structured_data.png"

// See https://developers.google.com/search/docs/data-types/logo?hl=en-GB
//"logo": "http://www.example.com/images/logo.png"

//SEE https://developers.google.com/search/docs/data-types/sitename?hl=en-GB
//"name": "Your WebSite Name",
// "alternateName": "An alternative name for your WebSite",

// social links
// SEE https://developers.google.com/search/docs/data-types/social-profile-links?hl=en-GB

export const SharedStructuredDataComponent = ({global}) => {
    if(!global) return null;
    return <Helmet
                script={[{
                    "type": "application/ld+json",
                    innerHTML: `{
                            "@context": "http://schema.org",
                            "@type": "Organization",
                            "name": "THE ICONIC",
                            "url": "https://edition.theiconic.com.au/",
                            "sameAs": [
                                "${global.instagram_link}",
                                "${global.facebook_link}",
                                "${global.youtube_link}",
                                "${global.pinterest_link}",
                                "${global.twitter_link}"
                            ]
                        }`
                }]}
            />
};

export const TodayStructuredDataComponent = (props) => {
    return (
            <Helmet
                script={[{
                    "type": "application/ld+json",
                    innerHTML: `{
                            "@context": "http://schema.org",
                            "@type": "WebSite",
                            "url": "https://edition.theiconic.com.au/",
                            "potentialAction": {
                                "@type": "SearchAction",
                                "target": "https://edition.theiconic.com.au/search?q={search_term_string}",
                                "query-input": "required name=search_term_string"
                            }
                        }`
                }]}
            />
    );
};

export const ArticleListStructuredDataComponent = ({articles}) => {
    if(!articles) return;

    const items = articles.slice(0, 3).map((item, i) => `{
                                "@type":"ListItem",
                                "position": ${i},
                                "url": "https://edition.theiconic.com.au${item.link.url}"
                            }`).join(',')

    return (
        <Helmet
            script={[{
                "type": "application/ld+json",
                innerHTML: `{
                            "@context": "http://schema.org",
                            "@type": "ItemList",
                            "itemListElement":[${items}]
                        }`
            }]}
        />
    );
}

const sanitizeStructuredData = (data) => JSON.stringify(data).split('<').join('\\u003c');

const ensureAbsoluteUrl = (url) => url && url.startsWith('//') ? 'https:' + url : url;

const getHeroImageUrl = (hero) => {
    if (!hero) return null;
    const breakpoints = ['desktop', 'tablet', 'mobile'];
    for (const breakpoint of breakpoints) {
        const images = hero[breakpoint];
        if (!Array.isArray(images) || images.length === 0) continue;
        const jpgs = images.filter(img => img && img.url && img.type !== 'image/webp');
        const best = jpgs.sort((a, b) => ((b.dimensions && b.dimensions.width) || 0) - ((a.dimensions && a.dimensions.width) || 0))[0];
        if (best) return ensureAbsoluteUrl(best.url);
    }
    return null;
};

export const ArticleStructuredDataComponent = ({article}) => {
    if (!article) return null;

    const allImageUrls = [
        getHeroImageUrl(article.horizontal_hero),
        getHeroImageUrl(article.vertical_hero),
    ].filter((url, index, self) => url && self.indexOf(url) === index);

    const isTheIconic = !article.author || article.author.name === 'THE ICONIC';
    const authorName = article.author ? article.author.name : 'THE ICONIC';
    const authorEntry = isTheIconic
        ? { '@type': 'Organization', 'name': authorName }
        : Object.assign(
            { '@type': 'Person', 'name': authorName },
            article.author.uid ? { 'url': `https://edition.theiconic.com.au/author/${article.author.uid}` } : {}
        );

    const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'NewsArticle',
        'mainEntityOfPage': {
            '@type': 'WebPage',
            '@id': `https://edition.theiconic.com.au${article.link.url}`,
        },
        'headline': article.title,
        'image': allImageUrls,
        'datePublished': article.published_date,
        'dateModified': article.published_date,
        'author': [authorEntry],
        'publisher': {
            '@type': 'Organization',
            'name': 'THE ICONIC',
            'logo': {
                '@type': 'ImageObject',
                'url': `https://edition.theiconic.com.au${publisher_logo}`,
                'width': 168,
                'height': 60,
            },
        },
        'description': article.summary_text || undefined,
    };

    return (
        <Helmet
            script={[{
                type: 'application/ld+json',
                innerHTML: sanitizeStructuredData(structuredData),
            }]}
        />
    );
}


// WEBPACK FOOTER //
// ./src/components/StructuredDataComponent.js